










import { GridItem, SerialNumber } from '@/types';
import Vue, { PropType } from 'vue';

export default Vue.extend({
  props: {
    item: {
      type: Object as PropType<GridItem>,
      default: undefined,
    },

    serialnumbers: {
      type: Array as PropType<SerialNumber[]>,
      default: () => [],
    },
  },

  computed: {
    serialnumber(): SerialNumber {
      return this.serialnumbers[this.item.index - 1];
    },
  },
});
